module.exports = __webpack_public_path__ + "assets/acdc961253f80fd83f59a11e9436626f.svg";